export default "__VITE_ASSET__BBUFmAg1__"